// Lucide icons as inline SVGs (no external dependency)
// Icons from lucide.dev, rendered as Preact components

const defaultAttrs = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};

const Icon = ({ children, size = 24, ...props }) => (
  <svg {...defaultAttrs} width={size} height={size} {...props}>
    {children}
  </svg>
);

const icons = {
  close: (size) => (
    <Icon size={size}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </Icon>
  ),
  fullscreen: (size) => (
    <Icon size={size}>
      <path d="M8 3H5a2 2 0 0 0-2 2v3" />
      <path d="M21 8V5a2 2 0 0 0-2-2h-3" />
      <path d="M3 16v3a2 2 0 0 0 2 2h3" />
      <path d="M16 21h3a2 2 0 0 0 2-2v-3" />
    </Icon>
  ),
  shrink: (size) => (
    <Icon size={size}>
      <path d="M8 3v3a2 2 0 0 1-2 2H3" />
      <path d="M21 8h-3a2 2 0 0 1-2-2V3" />
      <path d="M3 16h3a2 2 0 0 1 2 2v3" />
      <path d="M16 21v-3a2 2 0 0 1 2-2h3" />
    </Icon>
  ),
  minimize_meta: (size) => (
    <Icon size={size}>
      <path d="M4 14h6v6" />
      <path d="M20 10h-6V4" />
      <path d="m14 10 7-7" />
      <path d="m3 21 7-7" />
    </Icon>
  ),
  expand_meta: (size) => (
    <Icon size={size}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </Icon>
  ),
  play: (size) => (
    <Icon size={size}>
      <polygon points="6 3 20 12 6 21 6 3" />
    </Icon>
  ),
  pause: (size) => (
    <Icon size={size}>
      <rect x="14" y="4" width="4" height="16" rx="1" />
      <rect x="6" y="4" width="4" height="16" rx="1" />
    </Icon>
  ),
  map: (size) => (
    <Icon size={size}>
      <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
      <circle cx="12" cy="10" r="3" />
    </Icon>
  ),
  image: (size) => (
    <Icon size={size}>
      <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
      <circle cx="9" cy="9" r="2" />
      <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
    </Icon>
  ),
  download: (size) => (
    <Icon size={size}>
      <path d="M12 13v8l-4-4" />
      <path d="m12 21 4-4" />
      <path d="M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284" />
    </Icon>
  ),
  sharing: (size) => (
    <Icon size={size}>
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
      <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
    </Icon>
  ),
  arrow_left: (size) => (
    <Icon size={size}>
      <path d="m15 18-6-6 6-6" />
    </Icon>
  ),
  arrow_right: (size) => (
    <Icon size={size}>
      <path d="m9 18 6-6-6-6" />
    </Icon>
  ),
  chevron_up: (size) => (
    <Icon size={size}>
      <path d="m18 15-6-6-6 6" />
    </Icon>
  ),
  camera: (size) => (
    <Icon size={size}>
      <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
      <circle cx="12" cy="13" r="3" />
    </Icon>
  ),
  iso: (size) => (
    <Icon size={size}>
      <path d="m12 14 4-4" />
      <path d="M3.34 19a10 10 0 1 1 17.32 0" />
    </Icon>
  ),
  shutter_speed: (size) => (
    <Icon size={size}>
      <line x1="10" x2="14" y1="2" y2="2" />
      <line x1="12" x2="15" y1="14" y2="11" />
      <circle cx="12" cy="14" r="8" />
    </Icon>
  ),
  lens: (size) => (
    <Icon size={size}>
      <circle cx="12" cy="12" r="10" />
    </Icon>
  ),
  aperture: (size) => (
    <Icon size={size}>
      <circle cx="12" cy="12" r="10" />
      <path d="m14.31 8 5.74 9.94" />
      <path d="M9.69 8h11.48" />
      <path d="m7.38 12 5.74-9.94" />
      <path d="M9.69 16 3.95 6.06" />
      <path d="M14.31 16H2.83" />
      <path d="m16.62 12-5.74 9.94" />
    </Icon>
  ),
  calendar: (size) => (
    <Icon size={size}>
      <path d="M8 2v4" />
      <path d="M16 2v4" />
      <rect width="18" height="18" x="3" y="4" rx="2" />
      <path d="M3 10h18" />
    </Icon>
  ),
  eye: (size) => (
    <Icon size={size}>
      <circle cx="12" cy="12" r="3" />
      <path d="M2 12c.945-4.564 5.063-8 10-8s9.055 3.436 10 8c-.945 4.564-5.063 8-10 8s-9.055-3.436-10-8Z" />
    </Icon>
  ),
  minus: (size) => (
    <Icon size={size}>
      <circle cx="12" cy="12" r="10" />
      <path d="M8 12h8" />
    </Icon>
  ),
  plus: (size) => (
    <Icon size={size}>
      <circle cx="12" cy="12" r="10" />
      <path d="M8 12h8" />
      <path d="M12 8v8" />
    </Icon>
  ),
  keywords: (size) => (
    <Icon size={size}>
      <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
      <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
    </Icon>
  ),
  ellipsis: (size) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="10"/>
        <circle cx="17" cy="12" r="1"/>
        <circle cx="12" cy="12" r="1"/>
        <circle cx="7" cy="12" r="1"/>
    </Icon>
  ),
  close_arrow: (size) => (
    <Icon size={size}>
      <circle cx="12" cy="12" r="10"/>
      <path d="m12 8-4 4 4 4"/>
      <path d="M16 12H8"/>
    </Icon>
  ),
  copyright: (size) => (
    <Icon size={size}>
      <circle cx="12" cy="12" r="10" />
      <path d="M15.44 9.37a4 4 0 1 0 0 5.26" />
    </Icon>
  ),
  user: (size) => (
    <Icon size={size}>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </Icon>
  ),
};

export const MwlIcons = ({ icon, size = 24 }) => {
  const iconFn = icons[icon];
  if (!iconFn) return null;
  return iconFn(size);
};
